import { render } from "./AddOns.vue?vue&type=template&id=3239a9d9&scoped=true"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"

import "./AddOns.vue?vue&type=style&index=0&id=3239a9d9&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3239a9d9"]])

export default __exports__